import { bootstrapApplication } from '@angular/platform-browser';

import { AppLoader } from './app/app.loader';

void new AppLoader(bootstrapApplication).load();
